import React from 'react'
import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
    DatePicker,
} from '@material-ui/pickers';
import { isValid } from 'date-fns';
import { az, enUS, ru } from "date-fns/locale";
import { translate } from 'react-i18next';
import { Box } from '@mui/material';

function EndDatePicker(props) {
    const [selectedDate, setSelectedDate] = React.useState(null);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.updateDate(props.name, date);
    };
    const { placeholder, i18n, t } = props;
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: props.width }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={i18n.language == "ru" ? ru : i18n.language == 'en' ? enUS : az}>
                {props.label && <label>{props.label}</label>}
                <div className="dashboard-salary-order-container-box-select-datepicker-input">
                    <KeyboardDatePicker
                        disabled={props.readOnly}
                        className="dashboard-payment-container-data-section-content-container-form-input dashboard-payment-container-data-section-content-container-form-input__whole"
                        placeholder={placeholder}
                        format="dd.MM.yyyy"
                        value={props.value}
                        onChange={handleDateChange}
                        minDate={props.minDate}
                        maxDate={props.maxDate}
                        cancelLabel={t('cancel')}
                        okLabel={t('ok')}
                        disablePast={props?.disablePast}
                        keyboardbuttonprops={{
                            'aria-label': 'change date',
                        }}
                        keyboardIcon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <path d="M4.32861 12.8501V12.7857M8.26611 12.8501V12.7857M8.26611 9.35714V9.29269M11.7661 9.35714V9.29269M1.70361 5.92855H13.9536M3.28695 1V2.28586M12.2036 1V2.28571M12.2036 2.28571H3.45361C2.00387 2.28571 0.828613 3.43697 0.828613 4.85712V13.4286C0.828613 14.8487 2.00387 16 3.45361 16H12.2036C13.6534 16 14.8286 14.8487 14.8286 13.4286L14.8286 4.85712C14.8286 3.43697 13.6534 2.28571 12.2036 2.28571Z" stroke="#0179D2" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        }
                    />
                </div>
            </MuiPickersUtilsProvider >
        </Box>
    )
}

export default translate("translation")(EndDatePicker);